import React, { useState } from "react";
import { BarChart4, Link } from "lucide-react";
import { Button } from "@/components/ui";
import { SmartLinkExtraParamsDialog } from "@/containers";
import { SmartLinkExtraParam } from "@/services/bedrock";

interface SmartLinkUtmInfoProps {
  smartLinkId?: number;
  isCreatingNewLink?: boolean;
  pendingParams?: Partial<SmartLinkExtraParam>[];
  onPendingParamsChange?: (params: Partial<SmartLinkExtraParam>[]) => void;
}

export const SmartLinkUtmInfo: React.FC<SmartLinkUtmInfoProps> = ({
  smartLinkId,
  isCreatingNewLink,
  pendingParams,
  onPendingParamsChange,
}) => {
  const [isParamsOpen, setIsParamsOpen] = useState(false);

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-xl p-5 flex flex-col gap-4 shadow-sm mt-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-primary">
          <BarChart4 className="size-4" />
          <span className="text-sm font-bold uppercase tracking-wide">Dynamic Tracking Enabled</span>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <p className="text-xs text-slate-600 leading-relaxed">
          SocialCoach automatically adds tracking parameters to this link when it is clicked. This ensures your own
          Google Analytics and other integrations correctly attribute traffic to specific networks, campaigns, and team
          members.
        </p>
        <Button
          variant="outline"
          size="sm"
          className="h-8 bg-white border-primary/20 text-primary hover:bg-primary/5 transition-all text-sm"
          onClick={() => setIsParamsOpen(true)}
          type="button"
        >
          <Link className="size-3 mr-1.5" />
          Manage Tracking
        </Button>
      </div>

      {isParamsOpen && (
        <SmartLinkExtraParamsDialog
          open={isParamsOpen}
          onOpenChange={setIsParamsOpen}
          smartLinkId={smartLinkId}
          isCreatingNewLink={isCreatingNewLink}
          pendingParams={pendingParams}
          onPendingParamsChange={onPendingParamsChange}
        />
      )}
    </div>
  );
};
